import React from "react";
import OPOfflineIframe from "../../iframe-component/operation-offline/OPOffIframe";

const MerchantReportEmail = () => {
  return <OPOfflineIframe path="/operation/report" />;
};

export default React.memo(MerchantReportEmail);
